module.exports = __webpack_public_path__ + "img/pic_2.b3f41e47.png";